import type { DistanceBearingPitch } from '@ikegps/core-api';
import type { CollectionModelFieldAnchor, CollectionModelFieldVector } from '@ikegps/core-shared';
import { IMithrilComponent } from '../../components/mithril.component';
import { addStyles } from '../../components/theme';
import { m } from '../../mithril';
import { Services } from '../../services';
import { MeasurementState } from '../../state/measurement.state';
import { DistanceMeasureState } from '../../state/distance.measure.state';
import { TopologicalEditorMapOverlay } from './topological.editor.map.overlay';

export const CSS = {
	wrapper: 'c-MapWrapper',
};

const Style = {
	[CSS.wrapper]: {
		height: '100%',
		width: '100%',
	},
};

addStyles(Style);

interface ITopologicalEditorMapOptions {
	onTagClick?: (id: string) => void;
	onMapClick?: (position: google.maps.LatLng) => void;
	onVectorClick?: (collectionId: string, vectorId: string) => void;
	onVectorDragStart?: () => void;
	onVectorDragEnd?: (
		field: CollectionModelFieldVector | CollectionModelFieldAnchor,
		nextVector: DistanceBearingPitch
	) => void;
	measurementState?: MeasurementState;
	distanceMeasureState?: DistanceMeasureState;
}

export class TopologicalEditorMap extends IMithrilComponent {
	map: google.maps.Map | null = null;
	overlay: TopologicalEditorMapOverlay | null = null;

	name = 'TopologicalEditorMap';

	constructor(private options: ITopologicalEditorMapOptions) {
		super();

		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		Services.Map.isReadyPromise.then(() => {
			this.map = Services.Map.map;
			this.map.setMapTypeId('satellite');
			this.map.set('streetViewControl', true);

			this.overlay = new TopologicalEditorMapOverlay({
				map: this.map,
				onCollectionClick: (id) => this.options.onTagClick(id),
				onVectorClick: (collectionId, vectorId) => {
					this.options.onVectorClick(collectionId, vectorId);
				},
				onVectorDragStart: this.options.onVectorDragStart,
				onVectorDragEnd: this.options.onVectorDragEnd,
				measurementState: this.options.measurementState,
				distanceMeasureState: this.options.distanceMeasureState,
			});

			// Add map click listener if provided
			if (this.options.onMapClick) {
				this.map.addListener('click', (e: google.maps.MapMouseEvent) => {
					if (e.latLng) {
						this.options.onMapClick(e.latLng);
					}
				});
			}
		});
	}

	override onCreate(vnode) {
		Services.Analytics.trackEvent(Services.Analytics.EventCategory.BigMap, 'map:create', 'create', 1);
		this.map = Services.Map.attach(vnode.dom);
	}

	override onRemove() {
		if (this.overlay) {
			this.overlay.hide();
			this.overlay.onRemove();
		}
	}

	get nodes() {
		return m('div', {
			className: CSS.wrapper,
		});
	}
}
